module.exports = __webpack_public_path__ + "static/images/no-symbol.c2a4e28d76417088f766fbd052d07586.svg";